<template>
  <Modal
    :modalTitle="`Switch to ${database.name}?`"
    modalColor="danger"
    :isShowPopup="true"
    :buttons="buttons"
    :modalCallBack="onButton"
    :closeOnBackdrop="false"
    :centered="true"
  >
    <CAlert color="warning" class="mb-3">
      Everyone using TalentFind on this environment - candidates, recruiters,
      hospital staff and you - will be logged out. Work they haven't saved will
      be lost. For about 15-45 seconds nobody can use the system.
    </CAlert>
    <p class="mb-1">
      The app will show {{ database.label }}:
      {{ formatCount(database.candidates) }} candidates,
      {{ formatCount(database.jobs) }} jobs,
      {{ formatCount(database.users) }} users.
    </p>
    <p class="mb-3">
      Nothing is copied between the databases. Changes made in one stay in that
      one.
    </p>
    <label for="db-switch-confirm-name" class="mb-1">
      Type <strong>{{ database.name }}</strong> to confirm
    </label>
    <input
      id="db-switch-confirm-name"
      v-model="typedName"
      type="text"
      class="form-control"
      autocomplete="off"
      spellcheck="false"
    />
  </Modal>
</template>

<script>
import Modal from "@/components/reusable/Modal.vue";

const CANCEL = "Cancel";
const SWITCH = "Switch database";

export default {
  name: "DbSwitchConfirmModal",
  components: { Modal },
  props: {
    database: { type: Object, required: true },
  },
  data() {
    return { typedName: "" };
  },
  computed: {
    buttons() {
      return [
        { button: CANCEL, class: "secondary" },
        {
          button: SWITCH,
          class: "danger",
          disabled: this.typedName !== this.database.name,
        },
      ];
    },
  },
  methods: {
    formatCount(n) {
      return (n || 0).toLocaleString();
    },
    // The header's close button sends false.
    onButton(button) {
      if (button && button.button === SWITCH) {
        if (this.typedName === this.database.name) this.$emit("confirm");
        return;
      }
      this.$emit("cancel");
    },
  },
};
</script>
